import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Eye, EyeOff, Building2, Briefcase } from "lucide-react";

const COUNTRIES = [
  "Côte d'Ivoire", "Sénégal", "Cameroun", "Mali", "Burkina Faso", "Guinée",
  "Bénin", "Togo", "Niger", "Congo", "Gabon", "Madagascar", "France", "Autre",
];

interface JoinProfileFormProps {
  invitation: {
    email: string;
    first_name: string | null;
    last_name: string | null;
    role: string;
    grade: string | null;
  };
  orgData: { name: string; type: string } | null;
  password: string;
  setPassword: (v: string) => void;
  profession: string;
  setProfession: (v: string) => void;
  country: string;
  setCountry: (v: string) => void;
  phone: string;
  setPhone: (v: string) => void;
  showPassword: boolean;
  setShowPassword: (v: boolean) => void;
  onContinue: () => void;
}

export function JoinProfileForm({
  invitation, orgData, password, setPassword, profession, setProfession,
  country, setCountry, phone, setPhone, showPassword, setShowPassword, onContinue,
}: JoinProfileFormProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg border">
        {orgData?.type === "cabinet" ? (
          <Briefcase className="w-5 h-5 text-primary shrink-0" />
        ) : (
          <Building2 className="w-5 h-5 text-primary shrink-0" />
        )}
        <div>
          <p className="text-sm font-medium">{orgData?.name || "Organisation"}</p>
          <p className="text-xs text-muted-foreground capitalize">
            Rôle : {invitation.role}{invitation.grade ? ` · ${invitation.grade}` : ""}
          </p>
        </div>
      </div>

      <div className="space-y-2">
        <Label>Email (pré-rempli)</Label>
        <Input value={invitation.email} disabled className="bg-muted/40" />
      </div>

      {invitation.first_name && (
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-2">
            <Label>Prénom</Label>
            <Input value={invitation.first_name || ""} disabled className="bg-muted/40" />
          </div>
          <div className="space-y-2">
            <Label>Nom</Label>
            <Input value={invitation.last_name || ""} disabled className="bg-muted/40" />
          </div>
        </div>
      )}

      <div className="space-y-2">
        <Label>Profession / Fonction</Label>
        <Input
          value={profession}
          onChange={(e) => setProfession(e.target.value)}
          placeholder="Ex: Auditeur, Comptable..."
        />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-2">
          <Label>Pays</Label>
          <Select value={country} onValueChange={setCountry}>
            <SelectTrigger><SelectValue placeholder="Sélectionner..." /></SelectTrigger>
            <SelectContent>
              {COUNTRIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>Téléphone</Label>
          <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+225..." />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Choisissez un mot de passe <span className="text-destructive">*</span></Label>
        <div className="relative">
          <Input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Minimum 8 caractères"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground"
          >
            {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        </div>
      </div>

      <Button onClick={onContinue} className="w-full" disabled={password.length < 8}>
        Continuer vers les consentements
      </Button>
    </div>
  );
}
